import React, { Component } from 'react';
import './Products.css';

const $ = window.jQuery;

class Products extends Component {

  componentWillMount() {
    $(document).ready(function() {
      $('.collapse.in').prev('.panel-heading').addClass('active');
      $('#accordion, #bs-collapse')
        .on('show.bs.collapse', function(a) {
          $(a.target).prev('.panel-heading').addClass('active');
        })
        .on('hide.bs.collapse', function(a) {
          $(a.target).prev('.panel-heading').removeClass('active');
        });
    });
  }
  render() {
    return (
      <div id="products">
      <section className="product-hero secondaryhero">
        <div className="container">
          <h1>Products</h1>
        </div>
      </section>
      <section className="products">
        <div className="container">
          <div className="col-md-12 col-sm-12">
          <p>Please note, CPAK has access to nearly ANY packaging product to meet your needs.
          Our website includes only the products that we stock locally in our Detroit warehouse.
          Do not hesitate to inquire about a product that is not listed on our site.
          If we don&#39;t have it, we can get it. </p>
            <div className="panel-group wrap" id="bs-collapse">


              <div className="panel">
                <div className="panel-heading">
                  <h4 className="panel-title">
                    <a data-toggle="collapse" data-parent="#" href="#one">
                      Round Open-Head Plastic Pails
                    </a>
                  </h4>
                </div>
                <div id="one" className="panel-collapse collapse">
                  <div className="panel-body">
                    <p>Plastic pails are CPAK’s most popular product by in large. We stock locally, a variety of
                    plastic pails. Our pails range in size, color, certification, resin, and end-user utilization.
                    Plastic pails over the years have been used in every region of the world for every use thought
                    possible, or previously deemed impossible. From gathering water in the middle east to transporting
                    lubricants and chemicals in the midwest, plastic pails are essential to our way of living.
                    The majority CPAK’s pails are <b>FDA approved</b> for honey, flavors, seeds, ice cream and any food
                    product that you desire. We also carry UN rated plastic pails for hazardous materials like certain
                    chemicals and solvents. The UN certification only is applicable in the case that you are using a
                    UN Certified Cover. Our pails ranging from  1 US gallon to 7 US gallons are made from
                    HDPE (High Density Polyethylene) resin. Additionally, if you are not transporting or filling your
                    pails with food or any consumed products, we offer pails made from regrind HDPE resin. These pails
                    generally save you 10-15% and are primarily used for asphalt transportation or in-house for mixing
                    or pouring. All pails are available with plastic or metal handles. CPAK has the ability to label
                    your plastic pails with a private label via the newest and cleanest technology available today;
                    In-Mold Labeling. This process is subject to minimums, in which CPAK will stock locally for your
                    company, so long as your volumes quarterly meet the minimum run.Covers for Round Open-Head Plastic
                    Pails come Plain with Tear-Strip, plain UN, Rieke Spouted with a Tear-Strip, Rieke Spouted UN,
                    Snap-On, Tint Plug, and various other cover options. The Tear-Strip covers are tamper-evident.
                    Tamper-Evident containers will avoid contamination and certify that your products were not tampered
                     with in transit. </p>
                     <ul>
                      <li>1 US Gallon Round (HDPE) or (PP) Plastic Pails</li>
                      <li>1 US Gallon Gasket Covers</li>
                      <li>1 US Gallon Non-Gasket Covers</li>
                      <li>2 US Gallon Round (HDPE) or (PP) Plastic Pails</li>
                      <li>2 US Gallon Gasket Covers</li>
                      <li>2 US Gallon Non-Gasket Covers</li>
                      <li>3.5 US Gallon Round (HDPE) Plastic Pails</li>
                      <li>5 US Gallon Round (HDPE) Plastic Pails</li>
                      <li>6 US Gallon Round (HDPE) Plastic Pails</li>
                      <li>6.7 US Gallon Round (HDPE) Plastic Pails</li>
                      <li>3.5-6.7 US Gallon Round (HDPE) UN Rated Covers (Both with and without Rieke Spout)</li>
                      <li>3.5-6.7 US Gallon Round (HDPE) UN Rated Covers (Both with and without Rieke Spout)</li>
                     </ul>
                     <p>Square Open-Head Plastic Pails are very useful for various applications. CPAK stocks
                     locally, 2-4 gallon HDPE (High Density Polyethylene) pails and 4 gallon PP (Polypropylene)
                     pails. These pails range in size, color, material, and use. 4 gallon pails are very often used
                     for the transportation and storage of feta cheese, gelato, screws, bolts, and nuts and much
                     more. Square Open-Head Plastic Pail Covers are offered with a Tear-Strip with a gasket or no
                     gasket, and Snap-On. Most uses can be covered under both cover options, but we highly recommend,
                     for any application, the Tear-Strip cover, seeing that is a secure lock and Tamper-Evident.
                     Tamper-Evident containers will avoid contamination and certify that your products were not
                     tampered with in transit. </p>
                     <ul>
                      <li>3.5-gallon (15 Liter) Tight-Head Plastic Pails </li>
                      <li>5-gallon (18 Liter) Tight-Head Plastic Pails</li>
                      <li>5-gallon (20 Liter) Tight-Head Plastic Pails</li>
                      <li>6-gallon (22.5 Liter) Tight-Head Plastic Pails</li>
                      <li>70mm Tamper-Evident Closure</li>
                      <li>70mm Closure with Rieke pull-out spout</li>
                      <li>70mm Re-sealable Vent Closure</li>
                     </ul>
                </div>

              </div>
              </div>

              <div className="panel">
                <div className="panel-heading">
                  <h4 className="panel-title">
                    <a data-toggle="collapse" data-parent="#" href="#two">
                     Tight-Head Plastic Pails
                    </a>
                  </h4>
                </div>
                <div id="two" className="panel-collapse collapse">
                  <div className="panel-body">
                    <p>Tight-Head Plastic Pails are produced using FDA approved HDPE (High Density Polyethylene)
                    resin. Our product line includes, but is not limited to, square Tight-Head plastic pails ranging
                    in size from 3.5 US gallons to 6 US gallons. These pails offer available UN Certification for the
                    transportation of hazardous materials. Various colors are also available upon request. The
                    Closure’s for Plastic Tight-Heads are available in multiple sizes and multiple variations. The
                    most commonly used fitting for these pails is a 70mm closure. There are hundreds of different
                    70mm closure options, but we currently stock the most widely used closure: Tamper-Evident 70mm
                    closure, 70mm re-sealable vent closure, and 70mm closure with a Rieke pull-out spout.</p>
                    <ul>
                     <li>3.5-gallon (15 Liter) Tight-Head Plastic Pails </li>
                     <li>5-gallon (18 Liter) Tight-Head Plastic Pails</li>
                     <li>5-gallon (20 Liter) Tight-Head Plastic Pails</li>
                     <li>6-gallon (22.5 Liter) Tight-Head Plastic Pails</li>
                     <li>70mm Tamper-Evident Closure</li>
                     <li>70mm Closure with Rieke pull-out spout</li>
                     <li>70mm Re-sealable Vent Closure</li>
                    </ul>

                </div>
              </div>
              </div>

              <div className="panel">
                <div className="panel-heading">
                  <h4 className="panel-title">
                    <a data-toggle="collapse" data-parent="#" href="#three">
                      Open-Head Steel Pails
                    </a>
                  </h4>
                </div>
                <div id="three" className="panel-collapse collapse">
                  <div className="panel-body">
                  <p>Open-Head Steel Pails range in size, gauge, UN rating, lining, and color. Steel pails are
                  used for paints, lubricants, in-house uses, chemicals, and much more. UN Rated Steel Pails are
                  ideal for the transportation of hazardous materials, where 29 gauge steel pails are used primarily
                  for shop and in-house use. There is a lining on each pail specific to each use. Epoxy Phenolic
                  lining, Rust Inhibitor interior, and much more. CPAK stocks both black and gray steel pails. Please
                   note, as stated in our plastic pail details, we have access to nearly
                   ALL steel pails being manufactured, so don&#39;t hesitate to inquire about a pail that
                   may not be listed. The odds will always be in your favor that we can get you a specific product.
                   </p>
                   <ul>
                    <li>3.5-Gallon Open-Head Steel Pails </li>
                    <li>5 Gallon 26 gauge Open-Head Steel Pails UN Rated 1.9/Y100 Rust Inhibitor Interior</li>
                    <li>5 Gallon 24 gauge Solid Cover Rust Inhibitor Interior</li>
                    <li>5 Gallon 24 gauge Lug Cover with Rieke Spout Rust Inhibitor Interior</li>
                    <li>5 Gallon 26 gauge Open-Head Steel Pails UN Rated 1.9/Y100 Epoxy Phenolic Lined</li>
                    <li>5 Gallon 24 gauge Solid Cover Epoxy Phenolic Lined</li>
                    <li>5 Gallon 24 gauge Lug Cover with Rieke Spout Epoxy Phenolic Lined</li>
                    <li>5 Gallon 29 gauge Open-Head Steel Pails “Shop Pails” Rust Inhibitor Interior</li>
                    <li>5 Gallon 29 gauge Solid Cover Rust Inhibitor Interior</li>
                   </ul>
                  </div>
                </div>
              </div>

              <div className="panel">
                <div className="panel-heading">
                  <h4 className="panel-title">
                <a data-toggle="collapse" data-parent="#" href="#four">
                 Tight-Head Steel Pails
                </a>
              </h4>
                </div>
                <div id="four" className="panel-collapse collapse">
                  <div className="panel-body">
                    <p>Tight-Head Steel Pails are used often for air shipments of hazardous materials such as solvents,
                    chemicals, adhesives, lubricants, and much more. Tight-Heads that we stock are UN Rated.
                    <br />
                    Available fittings are Rieke Flexspout, 2” bung by 3/4” bung, 2” bung, and much more. </p>

                    <ul>
                      <li>5 Gallon 26 gauge Tight-Head Steel Pail PFR (Pierced for Rieke) UN Rated Black or Gray</li>
                    </ul>

                  </div>
                </div>
              </div>

              <div className="panel">
                <div className="panel-heading">
                  <h4 className="panel-title">
                    <a data-toggle="collapse" data-parent="#" href="#five">
                     Round Tin Cans
                    </a>
                  </h4>
                </div>
                <div id="five" className="panel-collapse collapse">
                  <div className="panel-body">
                    <p>
                      Tin Cans have been used for two centuries to store food. Over the course of 200 years, Tin
                      Cans have elevated from only the storage and transportation of food to uses beyond the norm.
                      We have customers that use to tin cans in the fire investigation industry, chemical industry,
                      paint industry and much more. Tin Cans are available with a gray lining to prevent rust and
                      corrosion when using water-based products, and unlined for the use with solvent-based products.
                      Our Tin Cans range in sizes from 1/2 US Pint to 1 US Gallon. You can purchase these cans in boxes
                      or bulk packed onto a pallet. 1 Gallon cans come without handles or NEB (No Ears and Bails) and
                      with handles or WEB (With Ears and Bails).
                    </p>

                    <ul>
                      <li>1/2 US Pint Unlined Tin Cans </li>
                      <li>1/2 US Pint Lined Tin Cans</li>
                      <li>1 US Pint Unlined Tin Cans</li>
                      <li>1 US Pint Lined Tin Cans</li>
                      <li>1 US Quart Unlined Tin Cans</li>
                      <li>1 US Quart Lined Tin Cans</li>
                      <li>1 US Gallon Unlined Tin Cans NEB</li>
                      <li>1 US Gallon Unlined Tin Cans WEB</li>
                      <li>1 US Gallon Lined Tin Cans NEB</li>
                      <li>1 US Gallon Lined Tin Cans NEB</li>

                    </ul>


                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="panel-heading">
                  <h4 className="panel-title">
                <a data-toggle="collapse" data-parent="#" href="#six">
                 F-Style Tin Cans
                </a>
              </h4>
                </div>
                <div id="six" className="panel-collapse collapse">
                  <div className="panel-body">
                    <p>
                      F-Style Tin Cans are used for paints and coatings, olive oil and much more. Our F-Style or
                      oblong tin cans are state of the art. We use snap-in plastic caps and have a higher fill volume
                      than the average Tin Can. There is only one manufacturer of tin cans in the entire United
                      States, driving cost and lead times up, while lowering quality and service. At CPAK we
                      understand the importance of keeping our customers in business. YOU are the only reason we
                      are in business in the first place. So, we sought out other options for F-Style tin cans and
                      were fortunate to find a source overseas. We stock these cans in our warehouse to keep your
                      operation running smoothly and cost effectively. F-Style tin comes from sizes as small as 1
                      Liter to as large as 5 Liters. All cans are UN Rated with appropriate UN boxes to match.
                    </p>

                    <ul>
                      <li>1/2 Liter (1 Pint) F-Style Tin Can with 32mm opening and plastic snap-in cap </li>
                      <li>1 Liter (1 Quart) F-Style Tin Can with 32mm opening and plastic snap-in cap</li>
                      <li>2.5 Liter F-Style Tin Can with 32mm opening and plastic snap-in cap</li>
                      <li>4 Liter (1 Gallon) F-Style Tin Can with 32mm opening and plastic snap-in cap</li>

                    </ul>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      </div>

    )
  }
}

export default Products;



/** WEBPACK FOOTER **
 ** ./src/components/Products/Products.js
 **/